import React, { useContext, useEffect, useState } from 'react';
// import Skeleton from 'react-loading-skeleton';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import Typography from '@digital-hig/mui/dist/Typography';
// eslint-disable-next-line import/no-extraneous-dependencies
import SvgIcon from '@mui/material/SvgIcon';
import SvgComplete from '@digital-hig/icon/lib/esm/display-icons/complete';
import {
  ENVIRONMENT, LRS_VERB_COMPLETED,
} from '../common/constants';
import { generateLRSID } from '../common/utilities';
import { getLearningRecords, hasFetchedLearningRecords } from '../store/userSlice';
import EnvContext from '../common/envContext';

const UnitCompletedBanner = ({
  unitId, isModuleComplete, moduleTitle, moduleId,
}) => {
  const itemId = unitId || moduleId;
  const learningRecords = useSelector(getLearningRecords);
  const fetchedLearningRecords = useSelector(hasFetchedLearningRecords);
  const [completedMsg, setCompletedMsg] = useState(false);
  const envContext = useContext(EnvContext);
  const env = envContext[ENVIRONMENT];

  useEffect(() => {
    if (hasFetchedLearningRecords && fetchedLearningRecords && learningRecords && Object.keys(learningRecords).length) {
      const problemRecord = learningRecords[generateLRSID({ id: itemId, env })];
      if (problemRecord && problemRecord.statements) {
        const filteredStatements = problemRecord.statements.filter((statement) => statement.verb === LRS_VERB_COMPLETED);

        if (filteredStatements.length) {
          const timeStamp = filteredStatements[0].timestamp;
          const unitCompletedTime = new Date(timeStamp).getTime();
          const isMoreThanADay = new Date() - new Date(unitCompletedTime) > (24 * 60 * 60 * 1000);
          if (!isMoreThanADay) {
            if (!isModuleComplete) {
              setCompletedMsg('You have completed this unit.');
            } else {
              const message = unitId ? `You completed all units in ${moduleTitle}.` : `You’re making progress! You completed all units in ${moduleTitle}.`;
              setCompletedMsg(message);
            }
          } else {
            const d = new Date(filteredStatements[0].timestamp);
            let completedStatementDate = d.toString();
            if (Intl && typeof Intl.DateTimeFormat === 'function') {
              const ye = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(d);
              const mo = new Intl.DateTimeFormat('en', { month: 'long' }).format(d);
              const da = new Intl.DateTimeFormat('en', { day: 'numeric' }).format(d);

              completedStatementDate = `${mo} ${da}, ${ye}`;
            }
            const itemType = unitId ? 'unit' : 'module';
            setCompletedMsg(`You completed this ${itemType} on ${completedStatementDate}.`);
          }
        } else {
          setCompletedMsg(false);
        }
      } else {
        setCompletedMsg(false);
      }
    }
  }, [learningRecords, unitId, hasFetchedLearningRecords, isModuleComplete]);

  if (completedMsg) {
    return (
      <RootElement>
        <SvgIcon size="medium"><SvgComplete /></SvgIcon>
        <Typography color="ink-on-background" variant="body-copy-small">{completedMsg}</Typography>
      </RootElement>
    );
  }
  return (
    <></>
  );
};

const RootElement = styled.div`
    display: flex;
    gap: 10px;
    background-color: rgba(234, 249, 241, 1);
    padding: 6px;
    border: 1px solid rgba(43, 194, 117, 1);
`;

UnitCompletedBanner.propTypes = {
  unitId: PropTypes.string,
  moduleId: PropTypes.string,
  isModuleComplete: PropTypes.bool.isRequired,
  moduleTitle: PropTypes.string.isRequired,
};

UnitCompletedBanner.defaultProps = {
  unitId: '',
  moduleId: '',
};

export default UnitCompletedBanner;
